module.exports = " <input :type=mode :class=classes v-model=data tabindex=0 :autofocus=autofocus :placeholder=config.placeholder /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/TextFieldtype.vue
// module id = 764
// module chunks = 0